// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-catalog-category-categories-type-1-mainCategories-bsxpz{display:grid}.components-catalog-category-categories-type-1-mainCategories-bsxpz.components-catalog-category-categories-type-1-desktop-ccnvz{grid-gap:24px;grid-template-columns:repeat(5,1fr)}.components-catalog-category-categories-type-1-mainCategories-bsxpz.components-catalog-category-categories-type-1-mobile-bkush{grid-gap:12px;grid-template-columns:repeat(3,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCategories": "components-catalog-category-categories-type-1-mainCategories-bsxpz",
	"desktop": "components-catalog-category-categories-type-1-desktop-ccnvz",
	"mobile": "components-catalog-category-categories-type-1-mobile-bkush"
};
module.exports = ___CSS_LOADER_EXPORT___;
